function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import func from '@/utils/preload';
export default {
  props: {
    typeStr: {
      // 判断是低代码还是审批流程
      type: String,
      default: ''
    },
    nodeConfig: {
      type: Object,
      default: {}
    },
    flowPermission: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isTried: {
      type: Boolean,
      default: false
    },
    tableId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      placeholderList: ['申请人', '审核人', '抄送人'],
      isInputList: [],
      isInput: false
    };
  },
  beforeCreate: function beforeCreate() {
    this.$vue.prototype.$func = func;
    this.$vue.directive('focus', {
      // 当被绑定的元素插入到 DOM 中时……
      inserted: function inserted(el) {
        el.focus();
      }
    });
  },
  mounted: function mounted() {
    if (this.nodeConfig.type == 1) {
      this.nodeConfig.error = !this.$func.setApproverStr(this.nodeConfig);
    } else if (this.nodeConfig.type == 2) {
      this.nodeConfig.error = !this.$func.copyerStr(this.nodeConfig);
    } else if (this.nodeConfig.type == 4) {
      for (var i = 0; i < this.nodeConfig.conditionNodes.length; i++) {
        this.nodeConfig.conditionNodes[i].error = this.$func.conditionStr(this.nodeConfig, i) == '请设置条件' && i != this.nodeConfig.conditionNodes.length - 1;
      }
    }
    this.getConditionType();
  },
  computed: {
    flowPermission1: function flowPermission1() {
      return this.$store.state.business.flowPermission;
    },
    approverConfig1: function approverConfig1() {
      return this.$store.state.business.approverConfig;
    },
    copyerConfig1: function copyerConfig1() {
      return this.$store.state.business.copyerConfig;
    },
    conditionsConfig1: function conditionsConfig1() {
      return this.$store.state.business.conditionsConfig;
    }
  },
  watch: {
    flowPermission1: function flowPermission1(data) {
      if (data.flag && data.id === this._uid) {
        this.$emit('update:flowPermission', data.value);
      }
    },
    approverConfig1: function approverConfig1(data) {
      if (data.flag && data.id === this._uid) {
        this.$emit('update:nodeConfig', data.value);
      }
    },
    copyerConfig1: function copyerConfig1(data) {
      if (data.flag && data.id === this._uid) {
        this.$emit('update:nodeConfig', data.value);
      }
    },
    conditionsConfig1: function conditionsConfig1(data) {
      if (data.flag && data.id === this._uid) {
        this.$emit('update:nodeConfig', data.value);
        this.getConditionType();
      }
    }
  },
  methods: {
    clickEvent: function clickEvent(index) {
      if (index || index === 0) {
        this.$set(this.isInputList, index, true);
      } else {
        this.isInput = true;
      }
    },
    blurEvent: function blurEvent(index) {
      if (index || index === 0) {
        this.$set(this.isInputList, index, false);
        this.nodeConfig.conditionNodes[index].nodeName = this.nodeConfig.conditionNodes[index].nodeName ? this.nodeConfig.conditionNodes[index].nodeName : '条件';
      } else {
        this.isInput = false;
        this.nodeConfig.nodeName = this.nodeConfig.nodeName ? this.nodeConfig.nodeName : this.placeholderList[this.nodeConfig.type];
      }
    },
    delNode: function delNode() {
      this.$emit('update:nodeConfig', this.nodeConfig.childNode);
    },
    addTerm: function addTerm() {
      var len = this.nodeConfig.conditionNodes.length;
      this.nodeConfig.conditionNodes.splice(len - 1, 0, {
        nodeName: '条件' + len,
        type: 3,
        onlyValue: this.$func.onlyValue(),
        priorityLevel: len.toString(),
        conditionList: [],
        isDefault: false,
        nodeUserList: [],
        childNode: null
      });
      var newLen = this.nodeConfig.conditionNodes.length;
      this.nodeConfig.conditionNodes[newLen - 1].priorityLevel = newLen.toString();
      // this.nodeConfig.conditionNodes.push()
      for (var i = 0; i < this.nodeConfig.conditionNodes.length; i++) {
        this.nodeConfig.conditionNodes[i].error = this.$func.conditionStr(this.nodeConfig, i) == '请设置条件' && i != this.nodeConfig.conditionNodes.length - 1;
      }
      this.$emit('update:nodeConfig', this.nodeConfig);
    },
    delTerm: function delTerm(index) {
      this.nodeConfig.conditionNodes.splice(index, 1);
      this.nodeConfig.conditionNodes.map(function (item, index) {
        item.priorityLevel = index + 1;
        item.nodeName = "\u6761\u4EF6".concat(index + 1);
      });
      for (var i = 0; i < this.nodeConfig.conditionNodes.length; i++) {
        this.nodeConfig.conditionNodes[i].error = this.$func.conditionStr(this.nodeConfig, i) == '请设置条件' && i != this.nodeConfig.conditionNodes.length - 1;
      }
      this.$emit('update:nodeConfig', this.nodeConfig);
      if (this.nodeConfig.conditionNodes.length == 1) {
        if (this.nodeConfig.childNode) {
          if (this.nodeConfig.conditionNodes[0].childNode) {
            this.reData(this.nodeConfig.conditionNodes[0].childNode, this.nodeConfig.childNode);
          } else {
            this.nodeConfig.conditionNodes[0].childNode = this.nodeConfig.childNode;
          }
        }
        this.$emit('update:nodeConfig', this.nodeConfig.conditionNodes[0].childNode);
      }
      this.getConditionType();
    },
    reData: function reData(data, addData) {
      if (!data.childNode) {
        data.childNode = addData;
      } else {
        this.reData(data.childNode, addData);
      }
    },
    setPerson: function setPerson(priorityLevel) {
      var type = this.nodeConfig.type;
      if (type == 0) {
        this.$store.commit('updatePromoter', true);
        this.$store.commit('updateFlowPermission', {
          value: this.flowPermission,
          flag: false,
          id: this._uid
        });
      } else if (type == 1) {
        this.$store.commit('updateApprover', true);
        this.$store.commit('updateApproverConfig', {
          value: _objectSpread(_objectSpread({}, JSON.parse(JSON.stringify(this.nodeConfig))), {
            settype: this.nodeConfig.settype ? this.nodeConfig.settype : 1
          }),
          flag: false,
          id: this._uid
        });
      } else if (type == 2) {
        this.$store.commit('updateCopyer', true);
        this.$store.commit('updateCopyerConfig', {
          value: JSON.parse(JSON.stringify(this.nodeConfig)),
          flag: false,
          id: this._uid
        });
      } else {
        // 打开条件设置
        if (this.typeStr == 'lowCode') {
          this.$store.commit('updateConditionDialog', true);
        } else {
          this.$store.commit('updateCondition', true);
        }
        this.$store.commit('updateConditionsConfig', {
          value: JSON.parse(JSON.stringify(this.nodeConfig)),
          priorityLevel: priorityLevel,
          flag: false,
          id: this._uid
        });
      }
    },
    arrTransfer: function arrTransfer(index) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      // 向左-1,向右1
      this.nodeConfig.conditionNodes[index] = this.nodeConfig.conditionNodes.splice(index + type, 1, this.nodeConfig.conditionNodes[index])[0];
      this.nodeConfig.conditionNodes.map(function (item, index) {
        item.priorityLevel = (index + 1).toString();
      });
      for (var i = 0; i < this.nodeConfig.conditionNodes.length; i++) {
        this.nodeConfig.conditionNodes[i].error = this.$func.conditionStr(this.nodeConfig, i) == '请设置条件' && i != this.nodeConfig.conditionNodes.length - 1;
      }
      this.$emit('update:nodeConfig', this.nodeConfig);
    },
    // 获取全部条件
    getConditionType: function getConditionType() {
      var _this = this;
      this.$nextTick(function () {
        var arr = [];
        var el = document.getElementsByClassName('condition-fields');
        if (el.length > 0) {
          for (var i = 0; i < el.length; i++) {
            if (el[i].lastElementChild.value) {
              if (el[i].lastElementChild.value.indexOf(',')) {
                // 多个时转化成数组
                arr.push.apply(arr, _toConsumableArray(el[i].lastElementChild.value.split(',')));
              } else {
                arr.push(el[i].lastElementChild.value);
              }
            }
          }
        }
        _this.$store.commit('upDateConditionsField', arr);
      });
    }
  }
};